module.exports = __webpack_public_path__ + "assets/pdf.1bf252b7.svg";